// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1586":"f3fb0972","5524":"7df730cf","8562":"7df730cf"}[chunkId] + ".chunk.css";
};